/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { IconButton } from '@material-tailwind/react';
import { CloseIcon } from 'car-insurance/components/common';
import { JSX, useState } from 'react';
import { getColorSchema } from '$/components/cms/components-user/ComponentCredtiCardPromotion/helpers/getColorSchema';

type HeaderCampaignProps = {
  isShown: boolean;
  textHeader?: string;
  color?: string;
};

export function RewardCampaignHeader(
  props: HeaderCampaignProps,
): JSX.Element | null {
  const [showCampaign, setShowCampaign] = useState(props.isShown);
  const activeColorSchema = getColorSchema(props.color ?? 'blue');

  if (!showCampaign) {
    return null;
  }

  return (
    <div style={{ position: 'relative', width: '100%', minHeight: '40px' }}>
      <div
        style={{
          background: activeColorSchema.topGradient,
          position: 'absolute',
          width: '100%',
          height: '100%',
          transition: 'opacity 0.2s ease-in-out',
        }}
      />
      <div
        className="mhg-alpha-rewards-lead-capture-frame relative z-1 flex flex-row items-center justify-between px-4 py-spacing/padding/soft-8px text-white lg:p-0"
        style={{
          height: '100%',
          margin: '0 auto',
        }}
      >
        <div className="flex flex-row items-center ">
          {props.textHeader ? (
            <span
              className="mhg-alpha-typography-body-2"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: props.textHeader }}
            />
          ) : null}
        </div>
        <IconButton
          variant="text"
          aria-label="Close campaign banner"
          onClick={() => setShowCampaign(false)}
        >
          <CloseIcon colorClass="text-white text-[20px]" />
        </IconButton>
      </div>
    </div>
  );
}
